import { render, staticRenderFns } from "./cropModel.vue?vue&type=template&id=b24ad9d2&scoped=true"
import script from "./cropModel.vue?vue&type=script&lang=js"
export * from "./cropModel.vue?vue&type=script&lang=js"
import style0 from "./cropModel.vue?vue&type=style&index=0&id=b24ad9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24ad9d2",
  null
  
)

export default component.exports